import { useEffect, useState } from "react";
import useCustomerUsage from "../../data/useCustomerUsage";
import useCustomerDetails from "../../data/useCustomerDetails";
import { BanknotesIcon, ChatBubbleLeftEllipsisIcon, ChatBubbleLeftIcon } from "@heroicons/react/24/outline";
import StripeProductModal from "../shared/Stripe/StripeProductModal";
import { CheckoutSessionType } from "../../models/Stripe";
import { FeatureStatus } from "../../models/Customer";

export function UsageTopup() {
  const { brand, features } = useCustomerDetails();
  const { increaseUsage } = useCustomerUsage();
  
  const [lookupTokens, setLookupTokens] = useState(0);
  const [smsTokens, setSmsTokens] = useState(0);

  const [stripeModalOpen, setStripeModalOpen] = useState(false);
  const [checkoutSessionType, setCheckoutSessionType] = useState<CheckoutSessionType>(CheckoutSessionType.LookupToken);

  const [lookupEnabled, setLookupEnabled] = useState(false);
  const [smsEnabled, setSmsEnabled]       = useState(false);

  const checkout = (CheckoutSessionType: CheckoutSessionType) => {
    setCheckoutSessionType(CheckoutSessionType);
    setStripeModalOpen(true);
  }

  useEffect(() => {
    if (brand?.data?.data && !brand.isLoading) {
      setLookupTokens(brand.data.data.lookupTokens ?? 0);
      setSmsTokens(brand.data.data.smsTokens ?? 0);
    }
  }, [brand.data, brand.isLoading]);

  useEffect(() => {
    if (features.data && !features.isLoading) {
      setLookupEnabled(features.data.data.find(f => f.name === "Parts Lookup" && f.status == FeatureStatus.Enabled) ? true : false);
      setSmsEnabled(features.data.data.find(f => f.name === "Lead Management" && f.status == FeatureStatus.Enabled) ? true : false);
    }
  }, [features.data, features.isLoading]);

  return (
    <div className="flex gap-4">
      <StripeProductModal open={stripeModalOpen} setOpen={setStripeModalOpen} mutation={increaseUsage} sessionType={checkoutSessionType} />
      {lookupEnabled && (
        <div className="flex items-center text-amber-900 gap-2 text-md cursor-pointer transition-all hover:scale-125 hover:text-amber-700" 
          onClick={() => checkout(CheckoutSessionType.LookupToken)}
        >
          <BanknotesIcon className="h-5 w-5" />
          {lookupTokens}
        </div>
      )}
      {smsEnabled && (
        <div className={`flex items-center  gap-2 text-md cursor-pointer transition-all hover:scale-125 
          ${smsTokens > 0 ? "text-emerald-900 hover:text-emerald-700" : "text-red-900 hover:text-red-700"}`}
          onClick={() => checkout(CheckoutSessionType.SmsToken)}
        >
          <ChatBubbleLeftEllipsisIcon className="h-5 w-5" />
          {smsTokens}
        </div>
      )}
    </div>
  )
}